import { axiosInstance } from "../../../axios/axiosInstance";

const API_ORGANISATION = "organization";
const API_SUPER_ADMIN = "admin";
const UPDATE_ORG_PERMISSIONS = API_ORGANISATION + "/role-permissions/update";

const UPDATE_SUPER_ADMIN_PERMISSIONS =
  API_SUPER_ADMIN + "/role-permissions/update";

export const updateOrgPermissions = (dataToBeSent) => {
  return axiosInstance.post(UPDATE_ORG_PERMISSIONS, dataToBeSent);
};

export const updateSuperAdminPermissions = (dataToBeSent) => {
  return axiosInstance.post(UPDATE_SUPER_ADMIN_PERMISSIONS, dataToBeSent);
};
